import { jsx as _jsx } from "react/jsx-runtime";
import { defaultItem_SmartDocStaticParam, smartDocParamType_External } from '@app/advisor-content-shared';
import { filterDuplicates, generateHex, sortArray } from '@nu-art/ts-common';
import { _className } from '@nu-art/thunderstorm-frontend';
// ######################## Translation of note template to preview text ########################
const translateNoteTemplateSectionToTextBlock = (sections, addNewLines = false) => {
    const nodes = [];
    sections.forEach((section, index) => {
        const sectionNodes = [];
        if (section.title)
            sectionNodes.push(_jsx("b", { className: 'section__title', children: section.title }, generateHex(5)));
        if (section.content)
            sectionNodes.push(_jsx("span", { className: 'section__content', children: section.content }, generateHex(5)));
        if (section.subSections.length)
            sectionNodes.push(_jsx("span", { className: 'section__sub-sections', children: translateNoteTemplateSectionToTextBlock(section.subSections) }, generateHex(5)));
        const sectionClassName = _className('section', section.isIndented && 'indent');
        nodes.push(_jsx("span", { className: sectionClassName, children: sectionNodes }, generateHex(5)));
        if (addNewLines)
            nodes.push('\n');
    });
    return nodes;
};
export const translateNoteTemplateToNodes = (template) => {
    const nodes = [];
    if (template.title)
        nodes.push(_jsx("b", { children: template.title }, generateHex(5)), '\n\n');
    nodes.push(...translateNoteTemplateSectionToTextBlock(template.sections, true));
    return nodes;
};
// ######################## Extraction of param keys from note template ########################
const paramRegex = new RegExp(/\{([^{}]*)\}/g);
const extractParamKeysFromTemplateSection = (section) => {
    const paramKeys = [];
    //Extract from content
    if (section.content) {
        const matches = section.content.matchAll(paramRegex);
        for (const match of matches)
            paramKeys.push(match[1]);
    }
    paramKeys.push(...section.subSections.map(extractParamKeysFromTemplateSection).flat());
    return paramKeys;
};
export const extractParamKeysFromNoteTemplate = (template) => {
    return filterDuplicates(template.sections.map(extractParamKeysFromTemplateSection).flat());
};
// ######################## Param Builder for note template ########################
export const noteTemplateParamBuilder = (paramKeys, existingParams) => {
    const params = existingParams.filter(param => param.type === smartDocParamType_External || paramKeys.includes(param.key));
    const existingParamKeys = params.map(p => p.key);
    const paramsToCreateKeys = paramKeys.filter(key => !existingParamKeys.includes(key));
    //Start out each new param as a static param
    const newParams = paramsToCreateKeys.map(key => defaultItem_SmartDocStaticParam(key));
    params.push(...newParams);
    return sortArray(params, param => param.key);
};
//# sourceMappingURL=utils.js.map